export default __webpack_public_path__ + "static/media/dot_connected.e390772b.svg";